import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Buildings } from "@phosphor-icons/react";

/**
 * Guards multi-tenant pages behind a tenant selection for super_admin.
 * Company-scoped users pass through automatically.
 */
export default function TenantGuard({ children }) {
  const { user, tenantId, setTenantId } = useAuth();
  const [tenants, setTenants] = useState([]);

  useEffect(() => {
    if (user?.role === "super_admin") api.get("/tenants").then(({ data }) => setTenants(data)).catch(() => {});
  }, [user?.role]);

  if (user?.role !== "super_admin") return children;
  if (tenantId) return children;

  return (
    <div className="max-w-2xl mx-auto mt-12 border border-zinc-200 bg-white rounded-sm p-8" data-testid="tenant-guard-banner">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-emerald-100 border border-emerald-300 rounded-sm grid place-items-center shrink-0"><Buildings size={22} className="text-emerald-800" /></div>
        <div className="flex-1">
          <div className="text-xs uppercase tracking-[0.25em] text-emerald-700">Multi-tenant view</div>
          <div className="font-display text-2xl font-bold mt-1">Choose a company to continue</div>
          <p className="text-sm text-zinc-500 mt-2">This module is scoped to a single tenant. Pick a company below or use the switcher in the top bar.</p>
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-2">
            {tenants.length === 0 && <div className="text-sm text-zinc-400 col-span-2">Loading tenants…</div>}
            {tenants.map((t) => (
              <Button key={t.id} variant="outline" onClick={() => setTenantId(t.id)} className="rounded-sm justify-start h-auto py-2.5" data-testid={`tenant-guard-pick-${t.id}`}>
                <div className="text-left">
                  <div className="font-display font-bold text-sm">{t.name}</div>
                  <div className="text-[10px] font-mono-plex text-zinc-500">{t.slug || t.domain || ""}</div>
                </div>
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
